module.exports = __webpack_public_path__ + "img/haseiyo.8abff11f.png";